import React,{useState,useEffect} from 'react'
import InputBox from '../../common/InputBox';
import SelectBox from '../../common/SelectBox';
import { Accordion, AccordionItem } from '@nextui-org/react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { useFormContext } from '../../Context/FormContext';
import MailCopyCheckbox from '../../common/MailCopyCheckbox';
import authQueries from '../../queries/authQueries';
import { Spin, } from 'antd';

const Step2 = ({setCurrent, current, navTab, setNavTab, rank, shipType}) => {
  
  const [placement, setPlacement] = useState("outside") 
  const [radius, setRadius] = useState("sm")
  const [isVisible, setIsVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRankVisible, setIsRankVisible] = useState(false);
  const { formData, updateFormData, formStates, updateFormStates } = useFormContext();

  const itemClasses = {
    base: "py-0 w-full",
    title: "font-normal text-medium",
    trigger: "px-2 py-0 rounded-lg h-14 flex items-center",
    indicator: "text-medium",
    content: "text-small px-2",
  };




  const validationSchema = yup.object({
    vessel_name: yup
      .string()
      .required('Vessel is required'),
    previous_port: yup
      .string()
      .required('Port is required'),
    imo_num: yup
      .string()
      // .typeError('IMO must be a number')
      .required('IMO number is required')
      .min(7, "⚠ Minimum number should be 7")
      .max(7, "⚠ Maximum number should be 7"),
    rank_on_board: yup
      .string()
      .required('Rank on Board is required'),
    email: yup
      .string('⚠ Enter your email')
      .email('⚠ Enter a valid email')
      .required('⚠ Email is required'),
});
    

const { register, reset, control, handleSubmit, watch, setValue, formState: { errors }, setError} = useForm({
    resolver: yupResolver(validationSchema),
});

const watchRankOnBoard = watch('rank_on_board');


const handleRankChange = async(e) => {
  const RankData = rank?.data?.data?.items?.find(item => item?.id === e)

  console.log(RankData.id)

  console.log(RankData.name)

  const selectedRankId = e;

  await updateFormData({ rank_on_board: e, rank_on_board_name: RankData?.name })

  if(RankData?.name === "Others"){
    setIsRankVisible(true)
    setValue('rank_on_board', RankData?.name)
    setValue('rank_on_board_other', formData?.rank_on_board_other)
    updateFormStates({ isRankVisible: 'true' })
    if(rank === 'true'){
      setIsRankVisible(true)

    }
  }
  else{
    setIsRankVisible(false)
    updateFormStates({ isRankVisible: 'false' })
    setValue('rank_on_board_other', '')
    delete formData.rank_on_board_other;
    // Assuming you have a function updateFormData in your context
    updateFormData((prevData) => {
      // Create a copy of the previous data
      const newData = { ...prevData };

      newData.rank_on_board = selectedRankId;

      // Remove rank_on_board_other and Others id
      delete formData.rank_on_board_other;

      return newData;
    });
    // delete formData.category_other;
  } 

}

useEffect(() => {
  if(formStates?.isRankVisible == true){
    setIsRankVisible(true)
    setValue('rank_on_board', formData?.rank_on_board_name)
    setValue('rank_on_board_other', formData?.rank_on_board_other)
  }
}, [current]);



  const inputItems = [
    {
      label: "Vessel Name - Will  be shared with your Employer",
      type:"text",
      component: InputBox,
      defaultValue: formData?.vessel_name,
      col: "col-span-6",
      mandatory: true,
      name:"vessel_name",
      maxLength:100
    },
    {
      label: "Previous Port",
      type: "text",
      component: InputBox,
      defaultValue: formData?.previous_port,
      col: "col-span-6",
      mandatory: true,
      name:"previous_port",
      maxLength:100
    },
    {
      label: "IMO Number",
      type:"number",
      component: InputBox,
      defaultValue: formData?.imo_num,
      col: "col-span-6",
      mandatory: true,
      name:"imo_num",
      maxLength:7
    },
    {
      label: `Rank on Board - Will not be shared with your Employer`,
      type: "text",
      defaultValue: formData?.rank_on_board_name,
      component: SelectBox,
      col: "col-span-6",
      mandatory: true,
      name:"rank_on_board",
      options: RanksCreate(rank),
      selected: handleRankChange,
      maxLength:100
    },
    {
      label: "Other Rank",
      type: "text",
      component: InputBox,
      col: "col-span-6",
      mandatory: true,
      isRankVisible: isRankVisible,
      name:"rank_on_board_other",
      maxLength:100
    },
  
  ]

  const OtpCheck  = authQueries.useOtpCheckMutation(

    (response) => {
      //   navigation.navigate('otp',{otp: response?.user?.token})
    setLoading(false)

    setNavTab(navTab + 1)
    setCurrent(current + 1)

    }
    
  );

  
  const onSubmit = async(data) => {

    setLoading(true)

    if(!data.rank_on_board_other && isRankVisible){

      setLoading(false)

      return setError('rank_on_board_other', {type: 'custom', message: 'Other Rank on Board is Required'})
      
    }
    
    await updateFormData(data);

    const updatedFormData = {
      ...formData,
      mail_issue_copy: "YES"
    }

    updateFormData(updatedFormData);

    const datavalues = {
      email: data?.email,
    };

    OtpCheck.mutateAsync(datavalues);
    
  }



  // const inputAccordion1 = [
  //   {
  //     label: "Email Address of Contact Person",
  //     radius: radius,
  //     type:"email",
  //     component: InputBox,
  //     col: "col-span-6",
  //     icon: 'icon-envelope4',
  //     name:"tech_manager_email",
  //     mandatory: false
  //   },
  //   {
  //     label: "Phone Number of Contact Person",
  //     radius: radius,
  //     type: "number",
  //     component: InputBox,
  //     col: "col-span-6",
  //     icon: 'icon-dialpad',
  //     name:"tech_manager_phone",
  //     mandatory: false
  //   }
  // ]

  // const inputAccordion2 = [
  //   {
  //     label: "Name of Company",
  //     radius: radius,
  //     type:"text",
  //     component: InputBox,
  //     col: "col-span-6",
  //     icon: 'icon-office',
  //     name:"crew_manager_cmpny",
  //     mandatory: false
  //   },
  //   {
  //     label: "Email Address of Contact Person",
  //     radius: radius,
  //     type:"email",
  //     component: InputBox,
  //     col: "col-span-6",
  //     icon: 'icon-envelope4',
  //     name:"crew_manager_email",
  //     mandatory: false
  //   },
  //   {
  //     label: "Phone Number of Contact Person",
  //     radius: radius,
  //     type: "number",
  //     component: InputBox,
  //     col: "col-span-6",
  //     icon: 'icon-dialpad',
  //     name:"crew_manager_phone",
  //     mandatory: false
  //   }
  // ]

 
  

  return (

    <div>
      <Spin spinning={loading} size='large'>
        <div className="tab-pane mt-2 mb-4 p-2" id="step2">

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className='gap-4 grid grid-cols-12'>
                {
                  inputItems?.map((item, index) => {

                    if(item.name === "rank_on_board_other" && !isRankVisible) 

                    {return}

                    return(

                      <div key={index} className={`${item.col}`}>
                        <item.component
                          register={register}
                          name={item.name}
                          type={item.type}
                          label={item.label}
                          defaultValue={item.defaultValue}
                          radius={radius}
                          placement={placement}
                          options={item.options}
                          description={placement}
                          selected={item.selected}
                          mandatory={item.mandatory}
                          error={errors}
                          maxLength={item.maxLength}
                          
                        />

                      </div> 
                    ) 
                  })
                }

            </div> 

            <div className="row mt-4">
                  
                  <div className="col">
                      <label className="haveInfo">Email<span style={{color: 'red', fontSize: 17, fontWeight: 'bold'}}>*</span></label>
                      <small>
                        SHIPCONREP requires email verification to accept your concern. The email address you provide does
                        not have to necessarily be your name identifier. A verification code will be sent to your email, valid
                        for 15 minutes. Your employer will not receive the email address from SHIPCONREP.
                      </small>
                  <input 
                      type="email" 
                      {...register('email')} 
                      defaultValue={formData?.email}
                      className="form-control"
                      name='email'
                      maxLength={100}
                  />

                  {

                      errors?.email &&

                          <div className='err'>
                              {errors?.email?.message}
                          </div>

                  }
                  
                  </div>

                  {/* <div className="reporting-checkbox-wror position-relative mt-3 ">
                    <MailCopyCheckbox />
                </div> */}
                  
            </div>

            
            {/* <div>

            <div className='mt-3 mb-3'><strong style={{fontSize: 15,}}>Preferred but Optional</strong></div>

                <Accordion
                    showDivider={false}
                    className='col-span-12 bg-[#fff] border border-slate-100 shadow-sm'
                    style={{fontSize:'12px'}}
                    variant="shadow"
                    itemClasses={itemClasses}
                  >
                    <AccordionItem
                      key="2"
                      className='text-sm'
                      aria-label="Apps Permissions"
                      title="Contact details of Technical Manager"
                    >
                    <div className='gap-4 grid grid-cols-12 mb-4'>
                      {
                        inputAccordion1?.map((item, index) => (
                          <div key={index} className={`${item.col} mt-3`}>
                            <item.component
                              register={register}
                              name={item.name}
                              type={item.type}
                              label={item.label}
                              radius={radius}
                              placement={placement}
                              options={item.options}
                              icon={item.icon}
                            />
                          </div>  
                        ))
                      }
                    </div>
                  </AccordionItem>
                </Accordion>

                <Accordion
                    showDivider={false}
                    className='col-span-12 mt-2 bg-[#fff] border border-slate-100 shadow-sm'
                    style={{fontSize:'12px'}}
                    variant="shadow"
                    itemClasses={itemClasses}
                  >
                    <AccordionItem
                      key="2"
                      className='text-sm'
                      aria-label="Apps Permissions"
                      title="Contact details of Crewing member"
                    >
                    <div className='gap-4 grid grid-cols-12 mb-4'>
                      {
                        inputAccordion2?.map((item, index) => (
                          <div key={index} className={`${item.col} mt-3`}>
                            <item.component
                              register={register}
                              name={item.name}
                              type={item.type}
                              label={item.label}
                              radius={radius}
                              placement={placement}
                              options={item.options}
                              icon={item.icon}
                            />
                          </div>  
                        ))
                      }
                    </div>
                  </AccordionItem>
                </Accordion>

            </div> */}

            {/* {JSON.stringify(formData)} */}

            <div className="row">

            <div className='col-md-6'>

              <div className="d-grid gap-2 mt-4 mb-4">

                  <button className="btn btn-primary btn-informant" 
                      
                      onClick={() => {
                          setNavTab(navTab - 1)
                          setCurrent(current - 1)
                      }}
                  >Back<i className="icon-arrow-left1"></i></button>

              </div>

            </div>

            <div className='col-md-6'>

              <div className="d-grid gap-2 mt-4 mb-4">
                <button className="btn btn-success btn-informant btn-informant-submit" type="submit">Verify <i className="icon-check"></i></button>
              </div>

            </div>

            </div>
          </form>

        </div>
      </Spin>
    </div>

  )
}

export default Step2



const RanksCreate =(rank)=> {
  let ranks = []
  if(rank?.data?.data?.items.length > 0){
    rank?.data?.data?.items?.map(item => {
      ranks.push({name: item.name, value: item.id})
    })    
  }

  return ranks
}